import { cn } from "@/lib/utils";
import { AnimatePresence, HTMLMotionProps, motion } from "framer-motion";
import { useEffect, useState } from "react";

type TextItem = {
  text: string;
  duration: number;
};

interface WordRotateProps {
  duration?: number;
  framerProps?: HTMLMotionProps<"h1">;
  className?: string;
  textItems: TextItem[];
}

export default function WordRotate({
  duration = 2500,
  framerProps = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.8, ease: "easeOut" }
  },
  textItems,
  className
}: WordRotateProps) {
  const [currentTextItem, setCurrentTextItem] = useState<TextItem>();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const timedEvents = [...textItems];

    const handleTimedEvents = () => {
      const nextEvent = timedEvents.shift();

      if (!nextEvent) return;

      setCurrentTextItem(nextEvent);

      timer = setTimeout(handleTimedEvents, nextEvent.duration);
    };

    handleTimedEvents();

    return () => {
      clearTimeout(timer);
    };
  }, [duration, textItems]);

  return (
    <div className="overflow-hidden mt-2 h-14">
      <AnimatePresence mode="wait">
        <motion.p
          key={currentTextItem?.text}
          className={cn(className)}
          {...framerProps}
        >
          {currentTextItem?.text}
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
